import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';
import * as d3 from "d3";
import $ from "jquery";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import "bootstrap/dist/js/bootstrap.bundle.min.js";// Added to index.tsx to fix issues with the Learn More button dropdown in the Featured Data Stories section
import './assets/styles/all.css'; // Added to help with the FontAwesome issue

// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';

(window as any).d3 = d3;
(window as any).jQuery = $;
(window as any).$ = $; // many plugins use just `$`
(window as any).Tabulator = Tabulator;

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

reportWebVitals();

